import { createProvider } from '@nvision/services/data-provider';
import { queryOptions } from '@tanstack/react-query';

import type { ProductsParams } from '../../models';
import { CACHE_KEYS } from '../../types';
import { logger } from '../../utils/logger';
import * as api from './api';
import { normalizeProducts } from './normalize';

export const fetchProducts = createProvider(api.fetchProducts)
  .andThen((res) => normalizeProducts(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      logger.warn('Fetch products search results list aborted');
    } else {
      logger.error('Fetch products search results list was failed:', error);
    }
    throw error;
  });

export const productsOptions = (params: ProductsParams) =>
  queryOptions({
    enabled: Boolean(params.productCode || params.productDesc),
    queryFn: ({ signal }) => fetchProducts(params, { signal }),
    queryKey: CACHE_KEYS.products(params),
  });
